/**
 * winepassport#363 (WP-017) — valores enviados como `sorting` a `GET /api/app/catalog/wines-paged`.
 * Deben coincidir con `WineSortOptions` (WinePassport.Domain, winepassport-api).
 */
export const WINE_SORT_OPTIONS = {
  priceAsc: 'price_asc',
  priceDesc: 'price_desc',
  newest: 'newest',
  bestSelling: 'best_selling',
} as const;

export type WineSortValue = (typeof WINE_SORT_OPTIONS)[keyof typeof WINE_SORT_OPTIONS];

export interface WineSortChoice {
  value: WineSortValue;
  labelKey: string;
}

export const WINE_SORT_CHOICES: WineSortChoice[] = [
  { value: WINE_SORT_OPTIONS.priceAsc, labelKey: '::Catalog:Sort:PriceAsc' },
  { value: WINE_SORT_OPTIONS.priceDesc, labelKey: '::Catalog:Sort:PriceDesc' },
  { value: WINE_SORT_OPTIONS.newest, labelKey: '::Catalog:Sort:Newest' },
  { value: WINE_SORT_OPTIONS.bestSelling, labelKey: '::Catalog:Sort:BestSelling' },
];
